import { render, staticRenderFns } from "./ga_card_item.vue?vue&type=template&id=5633e414&scoped=true"
import script from "./ga_card_item.vue?vue&type=script&lang=js"
export * from "./ga_card_item.vue?vue&type=script&lang=js"
import style0 from "./ga_card_item.vue?vue&type=style&index=0&id=5633e414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633e414",
  null
  
)

export default component.exports